module.exports = __webpack_public_path__ + "static/media/demand&debt.3a0a4dfa.png";